module.exports = __webpack_public_path__ + "img/copy.c48a9b5a.svg";